class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      p === "ov"
        ? this.classList.add("animate", "active")
        : (document.body.innerHTML = "");
    });

    this.launchTimer();
    this.launchTrustSlider();
    this.launchUpsellSlider();

    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        if (cart.item_count === 0) {
          this.hideAllModules();
          if (localStorage.getItem("storyThemeDrawerTimer"))
            localStorage.removeItem("storyThemeDrawerTimer");
        }

        if (document.querySelector(".drawer__module--free_shipping")) {
          console.log(this);
          const mainCart = document.querySelector("cart-drawer");
          const beforeText = document.querySelector(".free-shipping__left-amount");
          const afterText = document.querySelector(".free-shipping__success");
          const amount = document.querySelector(".free-shipping__amount");
          const text = document.querySelector(".free-shipping__gift-text");
          const drag = document.querySelector(".free-shipping__drag");
          const current = cart.total_price / 100;
          const textGift1 = document.querySelector(".drawer__module--free_shipping").dataset.giftOneText;
          const textGift2 = document.querySelector(".drawer__module--free_shipping").dataset.giftTwoText;
          const target = +document.querySelector(".drawer__module--free_shipping").dataset.target;
          const targetGift1 = +document.querySelector(".drawer__module--free_shipping").dataset.giftOneTrigger;
          const targetGift2 = +document.querySelector(".drawer__module--free_shipping").dataset.giftTwoTrigger;
          const amountToGift1 = new Intl.NumberFormat(document.body.dataset.shopLocale, { style: "currency", currency: document.body.dataset.shopCurrency }).format(targetGift1 - current);
          const amountToGift2 = new Intl.NumberFormat(document.body.dataset.shopLocale, { style: "currency", currency: document.body.dataset.shopCurrency }).format(targetGift2 - current);
          const gift1 = document.querySelector(".drawer__module--free_shipping").dataset.giftOne;
          const gift2 = document.querySelector(".drawer__module--free_shipping").dataset.giftTwo;
          const gifts = [];

          if (targetGift1 - current > 0) {
            amount.textContent = amountToGift1;
            text.textContent = textGift1;
            beforeText.classList.remove("hidden");
            afterText.classList.add("hidden");
            drag.style.width = `${(current * 100) / target}%`;
            
            if (mainCart.querySelector('.gift-1-item')) this.updateQuantity(mainCart.querySelector('.gift-1-item').dataset.index, 0);
            if (mainCart.querySelector('.gift-2-item')) this.updateQuantity(mainCart.querySelector('.gift-2-item').dataset.index, 0);
          } else if (targetGift2 - current > 0) {
            if (!window.refuseGiftOne) this.addGift(cart, [gift1]);
            window.refuseGiftOne = false;
            amount.textContent = amountToGift2;
            text.textContent = textGift2;
            beforeText.classList.remove("hidden");
            afterText.classList.add("hidden");
            drag.style.width = `${(current * 100) / target}%`;
            if (mainCart.querySelector('.gift-2-item')) this.updateQuantity(mainCart.querySelector('.gift-2-item').dataset.index, 0);
          } else {
            if (!window.refuseGiftOne && !window.refuseGiftTwo) this.addGift(cart, [gift1, gift2]);
            window.refuseGiftOne = false;
            window.refuseGiftTwo = false;
            afterText.classList.remove("hidden");
            beforeText.classList.add("hidden");
            drag.style.width = "100%";
          }
        }

        if (document.querySelector('.upsell-container')) {
          cart.items.forEach(item => {
            fetch(`/recommendations/products.json?product_id=${item.product_id}&limit=3`)
              .then(response => response.json())
              .then(data => {
                const recommendations = data.products;
                const upsellContainer = document.querySelector('.upsell-container');
                upsellContainer.innerHTML = "";
                
                recommendations.forEach(recommendation => {
                  if (!window.recommendations.some(item => item.id === recommendation.id)) window.recommendations.push(recommendation);
                  
                  const upsellPrice = new Intl.NumberFormat(document.body.dataset.shopLocale, { style: "currency", currency: document.body.dataset.shopCurrency }).format(recommendation.variants[0].price / 100);
                  const upsellPriceCompare = new Intl.NumberFormat(document.body.dataset.shopLocale, { style: "currency", currency: document.body.dataset.shopCurrency }).format(recommendation.variants[0].compare_at_price / 100);
                  const upsellHTML = `
                    <div class="swiper-slide upsell-${recommendation.id}">
                      <div class="upsell" data-upsell-id="${recommendation.id}">
                        <div class="upsell__media--container">
                          <img src="${recommendation.featured_image}" lazy="load" height="auto" width="100%" />
                        </div>
                        <div class="upsell__meta">
                          <div class="upsell__meta--head">
                            <p class="upsell__title">${recommendation.title}</p>
                            <p class="upsell__price"><span class="regular">${upsellPrice}</span><span class='compare'>${upsellPriceCompare > upsellPrice ? upsellPriceCompare : ""}</span></p>
                          </div>
                          <div class="upsell__meta--footer upsell__cta">
                            <product-form class="product-form">
                              <form
                                method="post"
                                action="/cart/add"
                                accept-charset="UTF-8"
                                class="form card__product-form"
                                enctype="multipart/form-data"
                                novalidate="novalidate"
                                data-type="add-to-cart-form"
                              >
                                <input type="hidden" name="form_type" value="product">
                                <input type="hidden" name="utf8" value="✓">
                                
                                ${
                                  recommendation.variants.length > 1 
                                  ? `<div class="select card__product-form-select">
                                       <select class="select__select" name="id">
                                         ${recommendation.variants.map(variant => `
                                           <option value="${variant.id}" ${variant.available ? '' : 'disabled'}>
                                             ${variant.title}
                                           </option>
                                         `).join('')}
                                       </select>
                                       <svg
                                          aria-hidden="true"
                                          focusable="false"
                                          class="icon icon-caret collapsible__icon"
                                          viewBox="0 0 12 13"
                                        >
                                          <path class="arrow" fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/>
                                          <path class="plus" d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                                          <path class="plus" d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                                          <path class="minus" d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                     </div>`
                                  : `<input type="hidden" name="id" value="${recommendation.variants[0].id}" class="product-variant-id">`
                                }
      
                                <button
                                  type="submit"
                                  name="add"
                                  class="product-form__submit upsell__button"
                                >
                                  <span>
                                    ${window.variantStrings.giftAddToCart}
                                  </span>
                                  <div class="loading-overlay__spinner hidden">
                                    <svg
                                      aria-hidden="true"
                                      focusable="false"
                                      class="spinner"
                                      viewBox="0 0 66 66"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                    </svg>
                                  </div>
                                </button>
                              </form>
                            </product-form>
                          </div>
                        </div>
                      </div>
                    </div>`;
                  
                  upsellContainer.innerHTML += upsellHTML;
                });
                this.updateRecommendationsVariants();
              });
          });
        }
      });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    this.launchUpsellSlider();

    document.body.classList.add("overflow-hidden");
  }

  updateRecommendationsVariants() {
    window.recommendations.forEach(recommendation => {
      const element = document.querySelector(`.upsell-${recommendation.id}`);
      if (!element) return;
      
      const upsellSelect = element.querySelector(".select__select");
      const regularPriceEl = element.querySelector(".upsell__price .regular");
      const comparePriceEl = element.querySelector(".upsell__price .compare");
  
      if (upsellSelect) {
        upsellSelect.addEventListener('change', (event) => {
          const selectedVariantId = event.target.value;
          const selectedVariant = recommendation.variants.find(variant => variant.id === parseInt(selectedVariantId));
  
          if (selectedVariant) {
            regularPriceEl.textContent = new Intl.NumberFormat(document.body.dataset.shopLocale, {
              style: "currency",
              currency: document.body.dataset.shopCurrency
            }).format(selectedVariant.price / 100);
  
            if (selectedVariant.compare_at_price) {
              comparePriceEl.textContent = new Intl.NumberFormat(document.body.dataset.shopLocale, {
                style: "currency",
                currency: document.body.dataset.shopCurrency
              }).format(selectedVariant.compare_at_price / 100);
            } else {
              comparePriceEl.textContent = "";
            }
          }
        });
      }
    })
  }

  addGift(cart, giftIds) {
    const allCartItems = document.querySelectorAll('.cart-item');
    const itemsToAdd = [];
  
    giftIds.forEach(giftId => {
      let productAlreadyInCart = false;
  
      allCartItems.forEach(cartItem => {
        if (cartItem.dataset.itemId === giftId) {
          productAlreadyInCart = true;
        }
      });
  
      if (!productAlreadyInCart) {
        itemsToAdd.push({ id: giftId, quantity: 1 });
      }
    });
  
    if (itemsToAdd.length > 0) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      })
      .then(response => response.json())
      .then(data => {
        if (data && !data.status) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift' });
        } else {
          console.error('Erreur lors de l’ajout des cadeaux au panier');
        }
      })
      .catch(error => console.error('Erreur réseau:', error));
    }
  }

  hideAllModules() {
    document
      .querySelectorAll(".drawer__module")
      .forEach((module) => (module.style.display = "none"));
  }

  launchTrustSlider() {
    if (document.querySelector("#drawer-trust__swiper")) {
      const trustDrawerCartSlider = new Swiper("#drawer-trust__swiper", {
        autoplay: { delay: 1000 },
        loop: true,
      });
    }
  }

  launchUpsellSlider() {
    if (document.querySelector(".drawer__upsell--inner.swiper")) {
      const upsellDrawerCartSlider = new Swiper(".drawer__upsell--inner.swiper", {
        slidesPerView: 1.3,
        spaceBetween: 15,
        scrollbar: {
          el: ".drawer__upsell--scrollbar"
        }
      });
    }
  }

  launchTimer() {
    if (document.querySelector(".drawer__module--timer")) {
      const timer = document.querySelector(".drawer__module--timer-time");
      const timerDrawerModule = document.querySelector(
        ".drawer__module--timer"
      );
      let time;

      if (localStorage.getItem("storyThemeDrawerTimer")) {
        time = localStorage.getItem("storyThemeDrawerTimer");
      } else {
        time = timerDrawerModule.dataset.duration * 60;
        localStorage.setItem("storyThemeDrawerTimer", time);
      }

      const tick = () => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        timer.textContent = `${minutes}:${seconds.toString().padStart(2, "0")}`;

        if (time > 0) {
          localStorage.setItem("storyThemeDrawerTimer", time--);
        } else {
          const xhr = new XMLHttpRequest();
          xhr.open("POST", "/cart/clear.js", true);
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
              localStorage.removeItem("storyThemeDrawerTimer");
              window.location.reload();
            }
          };
          xhr.send();
        }
      };

      tick();
      setInterval(() => {
        tick();
      }, 1000);
    }
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
